import React from 'react';

export const ProcessIcon = ({ className }) => {
	return (
		<svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2.30188 26.25H17.8019V28.75H2.30188V26.25ZM7.77855 10.0875L11.434 6.55L29.6981 24.225L26.0427 27.7625L7.77855 10.0875ZM16.9235 1.25L24.2344 8.325L20.579 11.8625L13.2681 4.7875L16.9235 1.25ZM5.9573 11.85L13.2681 18.925L9.61271 22.4625L2.30188 15.3875L5.9573 11.85Z" fill="#5F5F5F" />
		</svg>

	);
};
